import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-renda-presumida',
  templateUrl: './consulta-renda-presumida.component.html',
  styleUrls: ['./consulta-renda-presumida.component.scss']
})
export class ConsultaRendaPresumidaComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
